import "../../css/fonts.css";
import "../../css/container.css";
import "../../css/misc.css";
import "../../css/subpages.css";

import { useIsMobile } from "../../hooks/is.mobile";
import { Clickable } from "../../components/clickable.container";
import { useNavigate } from "react-router-dom";
import backIcon from "../../assets/back.png";

export const DevelopmentTools: React.FC<any> = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  return (
    <div>
      <div>
        {isMobile ? (
          <Clickable
            backgroundUrl={backIcon}
            onclick={() => {
              navigate("/services");
            }}
            style="back"
          />
        ) : (
          ""
        )}
        <div className={"title-text-font" + " " + "text-align" + " " + "title"}>
          Build Smarter, Iterate Faster!
        </div>
      </div>
      <div
        style={{
          paddingLeft: isMobile ? "10vw" : "4.5vw",
          paddingRight: isMobile ? "10vw" : "4.5vw",
          paddingTop: isMobile ? "6vw" : "2vw",
          paddingBottom: isMobile ? "6vw" : "1vw",
          fontSize: isMobile ? "3.5vw" : "2.5vw",
        }}
      >
        <p>
          <strong>Streamline your workflow!</strong> From intuitive editors and
          automation utilities to modular mechanics and dynamic systems,
          everything is crafted to give you the flexibility and control needed
          to bring your vision to life.
        </p>
      </div>

      <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        In Progress
      </div>
      {/* <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        Character Controller
      </div> */}
      {/* <div className="text-container">
        <div className={"simple-text" + " " + "text-align"}>
          opis+gif +link na yt
        </div>
      </div>

      <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        Camera sys
      </div>
      <div className="text-container">
        <div className={"simple-text" + " " + "text-align"}>
          opis+gif+link na yt
        </div>
      </div>

      <div
        className={"title-text-font" + " " + "text-align" + " " + "sub-title"}
      >
        Game brain
      </div>
      <div className="text-container">
        <div className={"simple-text" + " " + "text-align"}>
          opis+gif+link na yt
        </div>
      </div> */}
    </div>
  );
};
